import React from 'react';
import { useLang } from '../i18n/LangContext';
import { CONTACT } from '../data/content';
import { MapPin, ExternalLink } from 'lucide-react';

export default function HowToArrive() {
  const { t } = useLang();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-stretch">
      <div className="rounded-xl overflow-hidden border border-[#EAE4DA] bg-[#EEE7D9] min-h-[320px] md:min-h-[420px]">
        <iframe
          title="map"
          src={CONTACT.mapsEmbed}
          className="w-full h-full min-h-[320px] md:min-h-[420px] border-0"
          loading="lazy"
        />
      </div>
      <div className="flex flex-col justify-center">
        <div className="flex items-center gap-2 text-[#606F51] mb-5">
          <MapPin size={16} />
          <span className="text-[11px] uppercase tracking-[0.24em] font-medium">
            La Pobla de Cérvoles
          </span>
        </div>
        <p className="font-serif text-[#2C2A26] text-2xl md:text-3xl leading-snug mb-3">
          La Pobla de Cérvoles
        </p>
        <p className="text-[#6b6558] leading-relaxed mb-8 max-w-md">
          {t.arrive.approx}
        </p>
        <a
          href={CONTACT.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 self-start px-6 py-3.5 rounded-full bg-[#2C2A26] text-[#FDFBF7] font-medium hover:bg-[#3d3a35] transition-colors"
        >
          {t.arrive.cta}
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
  );
}
